import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipRecognitionTable = ({ data, type, accidentInsurance, size }) => {
    const { t } = useTranslation('translation', { keyPrefix: "traineeships.singleView.recognitionAndSupport.tableB"});

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>{t('noRecognitionAvailable')}</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('traineeshipType')}
                        </Col>
                        <Col>{type || ''}</Col>
                    </Row>
                    {type === "Voluntary" && (
                        <>
                            {/* ECTS Credits Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('awardECTS')}
                                </Col>
                                <Col>{data?.field_voluntary_award_ects ? t('yes') : t('no')}</Col>
                            </Row>
                            {data?.field_voluntary_award_ects && (
                                <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                    <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                        {t('numberOfCredits')}
                                    </Col>
                                    <Col>{data?.field_voluntary_number_of_credit || ''}</Col>
                                </Row>
                            )}

                            {/* Grades and Recognition Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('giveGrades')}
                                </Col>
                                <Col>{data?.field_voluntary_give_grades ? t('yes') : t('no')}</Col>
                            </Row>
                            {data?.field_voluntary_give_grades && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('traineeshipCert')}
                                        </Col>
                                        <Col>{data?.field_voluntary_tr_certificate ? t('yes') : t('no')}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('interview')}
                                        </Col>
                                        <Col>{data?.field_voluntary_interview ? t('yes') : t('no')}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('finalReport')}
                                        </Col>
                                        <Col>{data?.field_voluntary_final_report ? t('yes') : t('no')}</Col>
                                    </Row>
                                </>
                            )}

                            {/* Transcript Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('transcript')}
                                </Col>
                                <Col>{data?.field_voluntary_transcript ? t('yes') : t('no')}</Col>
                            </Row>

                            {/* Europass Mobility Section */}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('europassMobility')}
                                </Col>
                                <Col>{data?.field_voluntary_europass ? t('yes') : t('no')}</Col>
                            </Row>
                        </>
                    )}
                    {type === "Embedded" && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('awardedECTSCredits')}
                                </Col>
                                <Col>{data?.field_embedded_award_ects || ''}</Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('traineeshipCert')}
                                </Col>
                                <Col>{data?.field_embedded_tr_certificate ? t('yes') : t('no')}</Col>
                            </Row>
                            {data?.field_embedded_tr_certificate && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('interview')}
                                        </Col>
                                        <Col>{data?.field_embedded_interview ? t('yes') : t('no')}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('finalReport')}
                                        </Col>
                                        <Col>{data?.field_embedded_final_report ? t('yes') : t('no')}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('europassMobility')}
                                </Col>
                                <Col>{data?.field_embedded_europass ? t('yes') : t('no')}</Col>
                            </Row>
                        </>
                    )}
                    {type === "Graduate" && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('awardECTS')}
                                </Col>
                                <Col>{data?.field_recent_award_ects ? t('yes') : t('no')}</Col>
                            </Row>
                            {data?.field_recent_award_ects && (
                                <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                    <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                        {t('numberOfCredits')}
                                    </Col>
                                    <Col>{data?.field_recent_number_of_credits || ''}</Col>
                                </Row>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('europassMobility')}
                                </Col>
                                <Col>{data?.field_recent_europass ? t('yes') : t('no')}</Col>
                            </Row>
                        </>
                    )}
                    
                    {/* Accident Insurance Section */}
                    {accidentInsurance && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}>
                                    <strong>{t('accidentInsuranceForTrainee')}</strong>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('accidentInsurance')}
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins ? t('yes') : t('no')}</Col>
                            </Row>
                            {accidentInsurance?.field_acc_ins && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('coverageOnTheWay')}
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_way ? t('yes') : t('no')}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('coverageDuringTravel')}
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_travel ? t('yes') : t('no')}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('liabilityInsurance')}
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins_liability ? t('yes') : t('no')}</Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipRecognitionTable;